import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-36ea9ca1"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "footer-count" };
const _hoisted_2 = { class: "footer-count__title" };
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-question-12px" }, null, -1));
const _hoisted_5 = {
    key: 0,
    class: "footer-count__error"
};
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-customer" }, null, -1));
const _hoisted_7 = {
    key: 1,
    class: "footer-count__people"
};
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-customer" }, null, -1));
const _hoisted_9 = { class: "footer-count__people--number" };
const _hoisted_10 = {
    key: 0,
    class: "footer-count__people--time"
};
const _hoisted_11 = { class: "footer-count__people__name" };
const _hoisted_12 = { class: "footer-count__people" };
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-customer" }, null, -1));
const _hoisted_14 = { class: "footer-count__people--number" };
const _hoisted_15 = {
    key: 0,
    class: "footer-count__people--time"
};
import { computed, ref, onMounted } from 'vue';
import { useStore } from 'vuex';
import { formatDecimal } from '@/utilities/formatters';
import moment from 'moment';
import i18n from '@/i18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AudienceFooterCount',
    setup(__props) {
        const store = useStore();
        const timeSinceLastUpdate = ref(0);
        const lastUpdateTimestamp = ref(moment());
        const otoScoreIsEnabled = computed(() => store.getters.getEnabledOtoScore);
        const getCount = computed(() => store.getters['audienceManager/getCount']);
        const audienceHasConditions = computed(() => store.getters['audienceManager/hasAudienceData']);
        const isViewMode = computed(() => store.getters['audienceManager/isView']);
        const isCreationMode = computed(() => !isViewMode.value);
        const isLoadingCount = computed(() => getCount.value.loading);
        const hasCountError = computed(() => getCount.value.error);
        const shouldDisplayError = computed(() => hasCountError.value && !isLoadingCount.value);
        const hasPeopleCount = computed(() => getCount.value.people !== undefined && !isLoadingCount.value);
        const formattedPeopleCount = computed(() => formatDecimal(getCount.value.people, 2));
        const shouldDisplayUpdateTime = computed(() => {
            const hasAudienceConditions = audienceHasConditions.value;
            const hasValidPeopleCount = hasPeopleCount.value;
            return hasAudienceConditions && hasValidPeopleCount && isCreationMode.value;
        });
        const formattedUpdateMessage = computed(() => {
            const UPDATE_NOW_SECONDS = 5;
            const UPDATE_RECENT_SECONDS = 60;
            const isCalculatingCount = isLoadingCount.value;
            const secondsSinceLastUpdate = timeSinceLastUpdate.value;
            const time = Math.floor(secondsSinceLastUpdate);
            const updatedNow = secondsSinceLastUpdate < UPDATE_NOW_SECONDS;
            const updatedRecently = secondsSinceLastUpdate < UPDATE_RECENT_SECONDS;
            if (isCalculatingCount)
                return `${i18n.global.t('audiences.calculating')}...`;
            if (updatedNow)
                return i18n.global.t('audiences.updatedAt.now');
            if (updatedRecently)
                return i18n.global.t('audiences.updatedAt.atTime', { time: +time });
            return i18n.global.t('audiences.updatedAt.long-time');
        });
        onMounted(() => {
            setInterval(() => {
                timeSinceLastUpdate.value = moment().diff(lastUpdateTimestamp.value, 'seconds');
            }, 1000);
        });
        return (_ctx, _cache) => {
            const _component_el_popover = _resolveComponent("el-popover");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (otoScoreIsEnabled.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("span", _hoisted_2, [
                            _createTextVNode(_toDisplayString(isViewMode.value ? _ctx.$t('audiences.people-in-audience') : _ctx.$t('audiences.title')) + " ", 1),
                            (isCreationMode.value)
                                ? (_openBlock(), _createBlock(_component_el_popover, {
                                    key: 0,
                                    effect: "dark",
                                    trigger: "hover",
                                    placement: "top",
                                    width: 380
                                }, {
                                    reference: _withCtx(() => [
                                        _hoisted_4
                                    ]),
                                    default: _withCtx(() => [
                                        _createElementVNode("p", {
                                            innerHTML: _ctx.$t('audiences.otometro.tooltips.people'),
                                            class: "otometro-tooltip-content"
                                        }, null, 8, _hoisted_3)
                                    ]),
                                    _: 1
                                }))
                                : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", null, [
                            (shouldDisplayError.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                    _hoisted_6,
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('_error-message')), 1)
                                ]))
                                : (_openBlock(), _createElementBlock("p", _hoisted_7, [
                                    _hoisted_8,
                                    _createElementVNode("span", _hoisted_9, _toDisplayString(audienceHasConditions.value || getCount.value.people ? formattedPeopleCount.value : '-'), 1),
                                    (shouldDisplayUpdateTime.value)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(formattedUpdateMessage.value), 1))
                                        : _createCommentVNode("", true)
                                ]))
                        ])
                    ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t('audiences.people-in-audience')), 1),
                        _createElementVNode("p", _hoisted_12, [
                            _hoisted_13,
                            _createElementVNode("span", _hoisted_14, _toDisplayString(isViewMode.value || getCount.value.people >= 0 ? formattedPeopleCount.value : '-'), 1),
                            (shouldDisplayUpdateTime.value)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(formattedUpdateMessage.value), 1))
                                : _createCommentVNode("", true)
                        ])
                    ], 64))
            ]));
        };
    }
});
